module.exports = __webpack_public_path__ + "media/images/share/copy-33f7791728a702df3f68da35f7ccab67.svg";